module.exports = __webpack_public_path__ + "static/media/img19.c4bac34b.jpg";